import { render } from "./AttachmentSelector.vue?vue&type=template&id=3f76f478&scoped=true&ts=true"
import script from "./AttachmentSelector.vue?vue&type=script&lang=ts"
export * from "./AttachmentSelector.vue?vue&type=script&lang=ts"

import "./AttachmentSelector.vue?vue&type=style&index=0&id=3f76f478&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f76f478"]])

export default __exports__